module.exports = __webpack_public_path__ + "static/media/ahora200mg.a732a90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/ahora200mg.png
// module id = 197
// module chunks = 0